import { useState } from "react";
// models
import {
  PostulacionModel,
  initialValuesPostulacionModel,
} from "../models/PostulacionesModel/postulacion.model";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
import apiMaestras from "../api/Maestras/api-maestras";

export const useAsignarJurados = () => {
  const [allPostulacionesSinFiltro, setAllPostulacionesSinFiltro] = useState<any>([]);
  const [datosFiltro, setDatosFiltro] = useState<any[]>([]);
  const [preFiltro, setPreFiltro] = useState<any[]>([]);
  const [allPostulaciones, setAllPostulaciones] = useState<any>([]);
  const [modal] = useState<boolean>(false);
  const [postulacion] = useState<PostulacionModel>(initialValuesPostulacionModel);
  const [postulacionesSeleccionadas, setPostulacionesSeleccionadas] = useState<any>([]);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [categorias, setCategorias] = useState<any>([]);
  const [filasSeleccionadas, setFilasSeleccionadas] = useState<any>([]);
  const [modalAsignarJurados, setModalAsignarJurados] = useState(false);
  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([]);
  const [filtros, setFiltros] = useState<any>({
    buscarpalabra: "",
    linea_convocatoria: null,
    categoria: null,
    estado: "",
  });
  const cargarTodasPostulaciones = async () => {
    let { data: postulaciones } = await apiParticipantes.consultarPostulacionesEnPorcesoArtistas();

    let postulacionesMap = postulaciones.map((x: any, idx: any) => {
      return {
        ...x,
        index: idx + 1
      }
    })


    const postulacionesfiltro = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === "Aceptado" || x.estado === "Por evaluar"));

    let data = await apiMaestras.obtenerLineaConvocatoria();

    setLineasConvocatorias(data);

    setTotalRegistros(postulacionesfiltro.length);



    setDatosFiltro(postulacionesfiltro);
    setPreFiltro(postulacionesfiltro);
    setAllPostulacionesSinFiltro(postulacionesfiltro);

    return setAllPostulaciones(postulacionesfiltro);
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    setCantidadPáginas(value);
  };

  const obtenerCategoriasLineas = async (id_linea: number) => {
    let data = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
    return setCategorias(data.data);
  };


  const cambiarCheckbox = (datos: any) => {
    let infoupdate = datosFiltro.map((data: any) => {
      if (data.id_postulacion === datos.id_postulacion) {
        return {
          ...data,
          checked: !data.checked,
        };
      }
      return {
        ...data,
      };
    });

    let postulacionesSeleccionadas = infoupdate.filter(x => x.checked);
    let idsProyectos = postulacionesSeleccionadas.map((x: any) => {
      return {
        id_postulacion: x.id_postulacion
      }
    })

    localStorage.setItem("proyectosAsignados", JSON.stringify(idsProyectos))
    setPostulacionesSeleccionadas(postulacionesSeleccionadas)

    return setDatosFiltro(infoupdate);
  };

  const toggleSeleccionarTodos = () => {
    const allSelected = datosFiltro.every((data: any) => data.checked);

    let infoupdate = datosFiltro.map((data: any) => ({
      ...data,
      checked: !allSelected, // Cambiar todos al estado opuesto
    }));

    let postulacionesSeleccionadas = infoupdate.filter(x => x.checked);
    let idsProyectos = postulacionesSeleccionadas.map((x: any) => ({
      id_postulacion: x.id_postulacion
    }));

    localStorage.setItem("proyectosAsignados", JSON.stringify(idsProyectos));
    setPostulacionesSeleccionadas(postulacionesSeleccionadas);
    setDatosFiltro(infoupdate);
  };

  const cambiarFilasSeleccionadas = (filaseleccionada: any) => {
    return setFilasSeleccionadas({ filaseleccionada });
  };
  const limpiarFiltros = () => {
    setDatosFiltro(allPostulacionesSinFiltro);
    setFiltros({
      buscarpalabra: "",
      linea_convocatoria: null,
      categoria: null,
      estado: null,
    })
  };


  const handleLineaChange = async (id_linea: number) => {
    try {
      let { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      setCategorias(data);

      setFiltros({
        ...filtros,
        linea_convocatoria: id_linea
      })
    } catch (error) {
      console.log(error)
    }
  }

  const buscarpostulaciones = () => {
    let filtro = preFiltro;
    if (filtros.buscarpalabra !== '') {
      filtro = filtro.filter((x: any) => {
        if (x.nombre_propuesta !== null) {
          if (x.nombre_propuesta.toUpperCase().indexOf(filtros.buscarpalabra.trim().toUpperCase()) > -1) {
            return x;
          }
          //Filtro por código (radicado)
          if (x.radicado.toUpperCase().includes(filtros.buscarpalabra.trim().toUpperCase())) {
            return x;
          }
        }
      })
    }

    if (filtros.linea_convocatoria !== null) {
      filtro = filtro.filter((x: any) => {
        if (x.linea_convocatoria_id === filtros.linea_convocatoria) {
          return x;
        }
      })
    }

    if (filtros.categoria && filtros.categoria !== "") {
      filtro = filtro.filter((x: any) => {
        if (x.categoria_linea_convocatoria !== null && x.categoria_linea_convocatoria !== '') {
          if (x.categoria_linea_convocatoria === filtros.categoria) {
            return x;
          }
        }
      });
    }

    if (filtros.estado) {

      if (filtros.estado === "null") {
        filtro = filtro.filter((x: any) => {
          if (x.estado_jurado === null) {
            return x;
          }
        })
      }

      if (filtros.estado !== "null") {
        filtro = filtro.filter((x: any) => {
          if (x.estado_jurado === filtros.estado) {
            return x;
          }
        })
      }
    }
    setTotalRegistros(filtro.length)
    return setDatosFiltro(filtro)
  };
  const agregarPostulacionSeleccionada = (postulacion: any) => {
    let infoupdate: Array<PostulacionModel> = [];
    if (postulacionesSeleccionadas.length !== 0) {
      infoupdate = [...postulacionesSeleccionadas, postulacion];
    } else {
      infoupdate = [postulacion];
    }
    cambiarCheckbox(postulacion.id_postulacion);
    return setPostulacionesSeleccionadas(infoupdate);
  };
  return {
    allpostulaciones: allPostulaciones,
    setAllPostulaciones,
    cargarTodasPostulaciones,
    modal,
    postulacion,
    totalregistros: totalRegistros,
    cantidadpáginas: cantidadPáginas,
    cambiarCantidadPaginas,
    categorias,
    obtenerCategoriasLineas,
    cambiarCheckbox,
    filasseleccionadas: filasSeleccionadas,
    cambiarFilasSeleccionadas,
    setFilasSeleccionadas,
    modalasignarjurados: modalAsignarJurados,
    setModalAsignarJurados,
    lineasconvocatoria: lineasConvocatorias,
    filtros,
    setFiltros,
    limpiarFiltros,
    buscarpostulaciones,
    postulacionesSeleccionadas,
    setPostulacionesSeleccionadas,
    agregarPostulacionSeleccionada,
    handleLineaChange,
    datosFiltro,
    toggleSeleccionarTodos
  };
};
